import React from 'react';
import { ConvexAuthProvider } from '@convex-dev/auth/react';
import { ConvexReactClient } from 'convex/react';
import { node } from 'prop-types';

const convexUrl = process.env.GATSBY_CONVEX_URL;

// Only create client if URL is configured
const convex = convexUrl ? new ConvexReactClient(convexUrl) : null;

// No-op storage for SSR (localStorage not available)
const noopStorage = {
    getItem: () => null,
    setItem: () => {},
    removeItem: () => {},
};

export const ConvexClientProvider = ({ children }) => {
    if (!convex) {
        return children;
    }

    // During SSR, use ConvexAuthProvider with no-op storage
    // On client, use real localStorage (the default)
    const isSSR = typeof window === 'undefined';

    return (
        <ConvexAuthProvider
            client={convex}
            storage={isSSR ? noopStorage : undefined}
        >
            {children}
        </ConvexAuthProvider>
    );
};

ConvexClientProvider.propTypes = {
    children: node.isRequired,
};

export { convex };
